import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import type { Entity } from '@backstage/catalog-model';

export const isAiModelEntity = (entity: Entity): boolean =>
  entity.kind.toLowerCase() === 'component' && entity.spec?.type === 'ai-model';

export const essityAiModelCardModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [
    EntityCardBlueprint.make({
      name: 'ai-model-card',
      params: {
        type: 'content',
        filter: isAiModelEntity,
        loader: async () =>
          import('../components').then(m => <m.AiModelCard />),
      },
    }),
  ],
});
